'use strict'

export default (mockAxios) => {
  mockAxios.onGet(`/bcard-images/queues`).reply(200, {
    'success': true,
    'data': [
      {
        // OCR 1:取込待ち
        'sid_person': 1,
        'id': 1,
        'image_id': '01k20094169p8y3t',
        'status': '1',
        'exchange_date': '2019/12/01',
        'terminal': '1',
        'input_proxy': '0',
        'dispname': 'example.jpg',
        'openflag': '1',
        'formatted_exdate': '2019/12/01',
        'formatted_uploadtime': '2019/12/01 00:00:00',
        'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
        'lang_terminal': 'Web',
        'lang_status': '取込待ち',
        'prog_status': '1/2',
        'lang_openflag': '公開',
        'lang_input_proxy': '利用しない'
      },
      // 代行 1:取込待ち
      {
        // 画像＆直接入力共通
        'sid_person': 1,
        'id': 11,
        'openflag': '0',
        'lang_openflag': '非公開',
        'exchange_date': '2019/10/01',
        'formatted_exdate': '2019/10/01',
        'image_id': '01k20094169p8y3t',
        'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',

        // 画像登録状況
        'terminal': '2',
        'lang_terminal': 'モバイル',
        'formatted_uploadtime': '2019/10/01 00:00:00',
        'status': '1',
        'lang_status': '取込待ち',
        'prog_status': '1/3',
        'dispname': 'example.jpg',
        'input_proxy': '1',
        'lang_input_proxy': '利用する'
      },
      // 代行 4:修正サービス依頼中
      {
        // 画像＆直接入力共通
        'sid_person': 1,
        'id': 12,
        'openflag': '0',
        'lang_openflag': '非公開',
        'exchange_date': '2019/09/01',
        'formatted_exdate': '2019/09/01',
        'image_id': '01k20094169p8y3t',
        'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',

        // 画像登録状況
        'terminal': '1',
        'lang_terminal': 'Web',
        'formatted_uploadtime': '2019/09/01 00:00:00',
        'status': '4',
        'lang_status': '修正サービス依頼中',
        'prog_status': '2/3',
        'dispname': 'example.jpg',
        'input_proxy': '1',
        'lang_input_proxy': '利用する'
      }
    ],
    'pagination': {
      'page_count': 2,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 123,
      'limit': 100
    }
  })

  mockAxios.onGet(`/bcard-images/errors`).reply(200, {
    'success': true,
    'data': [
      // 代行 7:読取不能
      {
        // 画像＆直接入力共通
        'sid_person': 1,
        'id': 13,
        'openflag': '0',
        'lang_openflag': '非公開',
        'exchange_date': '2019/08/01',
        'formatted_exdate': '2019/08/01',
        'image_id': '01k20094169p8y3t',
        'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',

        // 画像登録状況
        'terminal': '1',
        'lang_terminal': 'Web',
        'formatted_uploadtime': '2019/08/01 00:00:00',
        'status': '7',
        'lang_status': '読取不能',
        'prog_status': '3/3',
        'dispname': 'example.jpg',
        'input_proxy': '1',
        'lang_input_proxy': '利用する'
      },
      // 代行 8:一部読取不能
      {
        // 画像＆直接入力共通
        'sid_person': 2,
        'id': 14,
        'openflag': '1',
        'lang_openflag': '公開',
        'exchange_date': '2019/07/01',
        'formatted_exdate': '2019/07/01',
        'image_id': '01k20094169p8y3t',
        'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',

        // 画像登録状況
        'terminal': '2',
        'lang_terminal': 'モバイル',
        'formatted_uploadtime': '2019/07/01 00:00:00',
        'status': '8',
        'lang_status': '一部読取不能',
        'prog_status': '3/3',
        'dispname': 'example.jpg',
        'input_proxy': '1',
        'lang_input_proxy': '利用する'
      }
    ],
    'pagination': {
      'page_count': 2,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 123,
      'limit': 100
    }
  })

  mockAxios.onPost(`/bcard-images/errors/delete`).reply(200, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/bcardImageRepositoryMock.js